import React from "react"
import { BLOCKS, MARKS } from "@contentful/rich-text-types"
import Font42 from "components/Fonts/Font42"
import Font32 from "components/Fonts/Font32"
import Font24 from "components/Fonts/Font24"
import Font22 from "components/Fonts/Font22"
import Font18 from "components/Fonts/Font18"
import Font16 from "components/Fonts/Font16"
import Font12 from "components/Fonts/Font12"
import styled from "styled-components"
import Hr from "components/Hr/Hr"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const fontSx = {
  width: "100%",
  display: "block",
  marginBottom: "20px",
  marginTop: "20px",
}

const Li = styled.li`
  && {
    margin-bottom: 10px;
    align-items: flex-start;
    &::before {
      margin-top: 8px !important;
      position: absolute;
      padding: 3px;
    }
    p {
      margin-bottom: 0 !important;
      margin-left: 15px;
    }
  }
`

export const options = {
  renderMark: {
    [MARKS.CODE]: text => (
      <span
        style={{
          minHeight: "20px",
          textAlign: "justify",
          width: "100%",
          display: "inline-block",
        }}
        mb={2}
      >
        {text.replace(/ ([a-zA-Z]) /g, " $1" + "\u00A0")}
      </span>
    ),
    [MARKS.BOLD]: text => <strong style={{ fontWeight: 900 }}>{text}</strong>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <Font16
          ta="justify"
          style={{ minHeight: "10px", marginBottom: "10px" }}
          mb={2}
        >
          {children}
        </Font16>
      )
    },
    [BLOCKS.LIST_ITEM]: (node, children) => {
      return <Li>{children}</Li>
    },
    [BLOCKS.HEADING_1]: (node, children) => {
      return (
        <Font42 component="h1" sx={fontSx}>
          {children}
        </Font42>
      )
    },
    [BLOCKS.HEADING_2]: (node, children) => {
      return (
        <Font32 component="h2" sx={fontSx}>
          {children}
        </Font32>
      )
    },
    [BLOCKS.HEADING_3]: (node, children) => {
      return (
        <Font24 component="h3" sx={fontSx}>
          {children}
        </Font24>
      )
    },
    [BLOCKS.HEADING_4]: (node, children) => {
      return (
        <Font22 component="h4" sx={fontSx}>
          {children}
        </Font22>
      )
    },
    [BLOCKS.HEADING_5]: (node, children) => {
      return (
        <Font18 component="h5" fw={900} sx={fontSx}>
          {children}
        </Font18>
      )
    },
    [BLOCKS.HEADING_6]: (node, children) => {
      return (
        <Font18 component="h6" fw={900} sx={fontSx}>
          {children}
        </Font18>
      )
    },
    [BLOCKS.HR]: () => {
      return <Hr mt={4} mb={4} />
    },
    [BLOCKS.EMBEDDED_ASSET]: (node, el) => {
      const { gatsbyImageData, title } = node.data.target

      return <GatsbyImage image={getImage(gatsbyImageData)} alt={title} />
    },
  },
}

export const smallParagraphOptions = {
  renderMark: {
    [MARKS.CODE]: text => (
      <span
        style={{
          minHeight: "20px",
          textAlign: "justify",
          width: "100%",
          display: "inline-block",
        }}
        mb={2}
      >
        {text.replace(/ ([a-zA-Z]) /g, " $1" + "\u00A0")}
      </span>
    ),
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      return (
        <Font12 ta="justify" style={{ minHeight: "20px" }} mb={1}>
          {children}
        </Font12>
      )
    },
    [BLOCKS.LIST_ITEM]: (node, children) => {
      return <Li>{children}</Li>
    },
  },
}
